import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class PortfolioService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allPortfolio(): Promise<any> {
        return this.httpmanagerService.HttpGet('portfolio', "").then(function (data) {
            return data;
        });
    }
    iPortfolio(app, sku): Promise<any> {
        return this.httpmanagerService.HttpPost('portfolio', JSON.stringify(app), sku).then(function (data) {
            return data;
        });
    }
    dSliderimage(app, id): Promise<any> {
        return this.httpmanagerService.HttpPost('portfolio/removesliderimage', JSON.stringify(app), id).then(function (data) {
            return data;
        });
    }
    dsinglesliderimage(data, id): Promise<any> {
        return this.httpmanagerService.HttpPost('portfolio/removesinglesliderimage', JSON.stringify(data), id).then(data => {
            return data
        });
    }
    allimage(data): Promise<any> {
        return this.httpmanagerService.HttpPost('portfolio/imagelength/portfolioimage', JSON.stringify(data), "").then(data => {
            return data
        });
    }
    ilogoimage(image, name, sku, is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPostlogoImage('portfolio/uploadlogo', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    isinglesliderimage(image, name, sku, is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPostsinglesliderImage('portfolio/uploadsinglesliderimage', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    ibannerimage(image, name, sku, is_form_data): Promise<any> {
        return this.httpmanagerService.HttpPostbannerImage('portfolio/uploadbanner', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    isliderimage(image, name, sku, is_form_data) {
        return this.httpmanagerService.HttpPostsliderImage('portfolio/uploadsliderimage', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    iheadersliderimage(image, name, sku, is_form_data) {
        return this.httpmanagerService.HttpPostHeadersliderImage('portfolio/uploadheadersliderimage', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    iseoimage(image, name, sku, is_form_data) {
        return this.httpmanagerService.HttpPostseoImage('portfolio/uploadseoimage', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    ifeatureimage(image, name, sku, is_form_data) {
        return this.httpmanagerService.HttpPostfeatureImage('portfolio/uploadfeatureimage', JSON.stringify(name), image, is_form_data, sku).then(function (data) {
            return data;
        });
    }
    uPortfolioindex(app): Promise<any> {
        return this.httpmanagerService.HttpPost('portfolio/update/index', JSON.stringify(app), "").then(function (data) {
            return data;
        });
    }
    uPortfolio(id, data): Promise<any> {
        return this.httpmanagerService.HttpPut('portfolio', JSON.stringify(data), id).then(function (data) {
            return data;
        });
    }
    dPortfolio(id): Promise<any> {
        return this.httpmanagerService.HttpDelete('portfolio', id).then(data => {
            return data;
        })
    }
    isactive(id): Promise<any> {
        return this.httpmanagerService.HttpPut('portfolio/activate', "", id).then(function (data) {
            return data;
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/portfolio/portfolio.service.ts